import { ConfigProvider } from '@/components/ui';
import { themeConfig } from '@/configs/theme.config';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import colors from 'tailwindcss/colors';
import useDarkMode from '@/utils/hooks/useDarkMode';

const Theme = props => {
	const theme = useSelector(state => state.theme);
	const [isDark] = useDarkMode();

	const currentTheme = {
		...themeConfig,
		...theme,
		mode: isDark ? 'dark' : 'light',
	};

	const focusRing = colors[currentTheme.themeColor]?.[currentTheme.primaryColorLevel];

	useEffect(() => {
		if (focusRing) {
			document.documentElement.style.setProperty('--focus-ring', focusRing);
		}
	}, [focusRing]);

	return (<>
		<ConfigProvider value={currentTheme}>
			{props.children}
		</ConfigProvider>
	</>);
}

export default Theme;
